<template>
  <div class="login-screen">
    <div class="login-box">
      <div class="logo">知</div>
      <h2 class="login-title">对话小助手</h2>
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item label="用户名（邮箱/手机号/用户名）" prop="username">
          <el-input v-model.trim="form.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" show-password placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>

      <el-button type="primary" class="mz-primary" :loading="loading" style="width: 100%" @click="submit">
        登录
      </el-button>
    </div>
  </div>
</template>

<script>
import { authApi } from "../api";

export default {
  data() {
    return {
      loading: false,
      form: { username: "", password: "" },
      rules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate(async (ok) => {
        if (!ok) return;
        this.loading = true;
        try {
          const resp = await authApi.login(this.form);
          if (!resp || !resp.token) throw new Error("missing token");

          const user = resp.user || {};
          const username = user.name || this.form.username;
          const isAdmin = Number(user.is_admin) === 1 || user.is_admin === true;

          localStorage.setItem("token", resp.token);
          localStorage.setItem("username", username);
          localStorage.setItem("is_admin", isAdmin ? "1" : "0");
          localStorage.setItem("auth_user", JSON.stringify(user));

          if (String(user.name || "").trim() === "储昌宏") {
            this.$router.push("/leads");
          } else if (isAdmin) {
            this.$router.push("/departments");
          } else {
            this.$router.push("/home");
          }
        } catch (e) {
          // 错误提示由请求拦截器处理
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-screen {
  min-height: 100vh;
  height: 100vh;
  display: grid;
  place-items: center;
  padding: 18px;
  overflow: auto;
  background-image: url('../assets/background.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.login-screen::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.7);
  z-index: 1;
}

.login-screen > * {
  position: relative;
  z-index: 2;
}

.login-box {
  width: min(440px, 100%);
  background: rgba(30, 41, 59, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 22px;
  box-shadow: 
    0 0 30px rgba(6, 182, 212, 0.3),
    0 14px 36px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  padding: 40px;
  backdrop-filter: blur(20px);
  transition: all 0.3s ease;
}

.login-box:hover {
  box-shadow: 
    0 0 40px rgba(6, 182, 212, 0.4),
    0 14px 36px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  transform: translateY(-5px);
}

.logo {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: linear-gradient(130deg, #06b6d4, #10b981);
  display: grid;
  place-items: center;
  color: #fff;
  font-weight: 700;
  font-size: 24px;
  margin: 0 auto 20px;
  box-shadow: 0 12px 24px rgba(6, 182, 212, 0.4);
  position: relative;
  overflow: hidden;
}

.logo::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    to bottom right,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transform: rotate(45deg);
  animation: glow 3s infinite;
}

@keyframes glow {
  0% { transform: rotate(45deg) translateX(-100%); }
  100% { transform: rotate(45deg) translateX(100%); }
}

.login-title {
  text-align: center;
  margin: 0 0 12px;
  color: #f8fafc;
  font-weight: 600;
}

.login-tip {
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  margin: 0 0 30px;
}

/* 表单样式 */
:deep(.el-form-item__label) {
  color: #e2e8f0 !important;
  font-weight: 500;
}

:deep(.el-input__wrapper) {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

:deep(.el-input__input) {
  color: #f8fafc !important;
}

:deep(.el-input__wrapper:hover) {
  border-color: rgba(6, 182, 212, 0.5) !important;
  box-shadow: 0 0 0 1px rgba(6, 182, 212, 0.2) !important;
}

:deep(.el-input__wrapper.is-focus) {
  border-color: #06b6d4 !important;
  box-shadow: 0 0 0 1px rgba(6, 182, 212, 0.3) !important;
}

/* 按钮样式 */
.mz-primary {
  background: linear-gradient(130deg, #06b6d4, #10b981) !important;
  border: none !important;
  height: 48px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 16px rgba(6, 182, 212, 0.3) !important;
  transition: all 0.3s ease !important;
}

.mz-primary:hover {
  box-shadow: 0 10px 20px rgba(6, 182, 212, 0.4) !important;
  transform: translateY(-2px) !important;
}

.mz-primary:active {
  transform: translateY(0) !important;
}
</style>

